
import React, { forwardRef, useImperativeHandle } from 'react';
import { Form, Input, Button, Row, Col, DatePicker, Select } from 'antd';
import { IndexToStatusText ,IndexToOrderTypeText} from '../utils/common';
import { formItemLayout } from '../../../util/formItemLayoutConfig';
import './searchForm.less';

const { RangePicker } = DatePicker;
const { Option } = Select;

export const SearchForm = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const onFinish = () => {
    props.searchFn();
  };
  const onExport = () => {
    props.exportFn();
  };

  useImperativeHandle(ref, () => ({ form }));

  return (
    <div className='search-form-container-proposal'>
      <Form form={form} name="order-form" {...formItemLayout} onFinish={onFinish}>
        <Row>
          <Col span={6}>
            <Form.Item name="order_no" label='订货单号：' className='search-form-label'>
              <Input placeholder="订单号" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="sale_name" label='商品名称：' className='search-form-label'>
              <Input placeholder="商品名称" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="create_time" label='下单日期：' className='search-form-label'>
              <RangePicker format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <Form.Item name="supplier_name" label='供应商：' className='search-form-label'>
              <Input placeholder="供应商" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="order_status" label='订单状态：' className='search-form-label'>
              <Select placeholder='全部'>{Reflect.ownKeys(IndexToStatusText).sort().map(item => <Option key={item}>{IndexToStatusText[item]}</Option>)}</Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="order_type" label='订单来源：' className='search-form-label'>
              <Select placeholder='全部'>{Reflect.ownKeys(IndexToOrderTypeText).sort().map(item => <Option key={item}>{IndexToOrderTypeText[item]}</Option>)}</Select>
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.Item wrapperCol={{ span: 24 }}>
              <div className='search-form-btn-container'><Button type='primary' className='search-form-btn' htmlType="submit"> 查询 </Button></div>
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.Item wrapperCol={{ span: 24 }}>
              <div className='search-form-btn-container'><Button type='primary' className='search-form-btn' onClick={onExport}> 数据导出 </Button></div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div >
  );
});
